import {
  List as BaseList,
  ListItem,
  ListItemHeader as BaseListItemHeader,
  ListItemContent,
} from "#app/components/layouts/FormList.jsx";

export { ListItem, ListItemContent };

export function List({ spacing, ...rest }) {
  return <BaseList spacing={spacing ?? { base: 6, md: 10 }} {...rest} />;
}

export function ListItemHeader({ titleProps = {}, ...rest }) {
  return (
    <BaseListItemHeader
      titleProps={{
        fontSize: { base: "lg", md: "xl" },
        fontWeight: "semibold",
        letterSpacing: "tight",
        ...titleProps,
      }}
      {...rest}
    />
  );
}
